import { ReduxState } from 'interfaces';
import React, { useState, useEffect, useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { SiPayModal } from 'utilities/components';
import { __ProfessionalVerifyModalProps } from './professionalVerify.interface';
import NationalCard from 'assets/images/nationalCard.png';
import { Button, Input } from '30pay/components';
import { post } from 'scripts';
import { API } from 'data/30pay.api';
import { FaImage } from 'react-icons/fa';
import ProfileProfessionalManualVerifyModalContent, {
    ProfessionalManualVerifyContentRef,
} from './manual/manualVerify.index';
import { Image } from 'antd';

const ProfileProfessionalVerifyModal: React.FC<ConnectedProps<typeof connector> & __ProfessionalVerifyModalProps> =
    function (props: ConnectedProps<typeof connector> & __ProfessionalVerifyModalProps) {
        const [nationalCardSerial, setNationalCardSerial] = useState('');
        const [loading, setLoading] = useState(false);
        const [kycLink, setKycLink] = useState('');
        const [seconds, setSeconds] = useState(5);
        const [showImage, setShowImage] = useState(false);
        const [is500Error, setIs500Error] = useState(false);
        const [isManual, setIsManual] = useState(true);
        const isValidSerial = nationalCardSerial.length === 10;
        const profileProfessionalManualVerifyModalContentRef = useRef<ProfessionalManualVerifyContentRef>(null);
        function reset() {
            setNationalCardSerial('');
            setShowImage(false);
            setKycLink('');
            setSeconds(5);
            setIs500Error(false);
            setIsManual(true);
        }
        useEffect(() => {
            if (kycLink && seconds > 0) {
                const timer = setInterval(() => {
                    setSeconds((s) => s - 1);
                }, 1000);
                return () => clearInterval(timer);
            }
        }, [kycLink, seconds]);

        const submitHandler = () => {
            if (!isValidSerial) return;

            setLoading(true);
            const body = {
                nationalCardSerial: nationalCardSerial?.toUpperCase(),
            };
            post<{ kycGatewayLink: string }>(API.level.requestUpgradeTo2, body)
                .then((res) => {
                    setKycLink(res.value.value.kycGatewayLink);
                    setTimeout(() => {
                        window.location.href = res.value.value.kycGatewayLink;
                    }, 5000);
                })
                .catch((err) => {
                    setIs500Error(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        const redirectToKyc = () => {
            if (kycLink) {
                window.location.href = kycLink;
            }
        };

        return (
            <SiPayModal
                footer={<></>}
                isOpen={props.isOpen}
                onClose={() => {
                    props.onClose(profileProfessionalManualVerifyModalContentRef.current?.getIsSuccess());
                }}
                title={
                    <div className="flex items-center gap-2">
                        <p className="text-xl font-bold text-darkPurple-100">احراز حرفه‌ای</p>
                        <div
                            className={`h-8 px-3 flex items-center rounded-lg justify-center ${isManual ? 'bg-[#205BFC1A]' : 'bg-[#1AB7591A]'}`}
                        >
                            <p className={`text-sm font-medium ${isManual ? 'text-primary-100' : 'text-[#1AB759]'}`}>
                                {isManual ? 'به صورت دستی' : 'آنی و اتوماتیک'}
                            </p>
                        </div>
                    </div>
                }
                afterClose={reset}
            >
                {!isManual ? (
                    <div className="flex flex-col gap-4">
                        <p className="text-sm font-medium text-black-100">
                            برای احراز هویت حرفه‌ای سریال کد ملی خود را وارد کنید و بعد از وارد کردن سریال کد ملی مراحل
                            احراز هویت حرفه‌ای رو انجام بدهید.
                        </p>
                        <div className="flex flex-col gap-2">
                            <label className="text-base font-bold text-darkPurple-100">سریال کد ملی:</label>
                            <Input
                                onPressEnter={submitHandler}
                                value={nationalCardSerial}
                                onChange={(e) => setNationalCardSerial(e.target.value)}
                                status={is500Error || (nationalCardSerial && !isValidSerial) ? 'error' : undefined}
                                dir={!!nationalCardSerial ? 'ltr' : 'rtl'}
                                placeholder="سریال کد ملی خود را وارد کنید"
                                maxLength={10} // Add this line for max length
                            />
                            {nationalCardSerial && !isValidSerial && (
                                <span className="text-red-500 text-sm">سریال کد ملی باید ۱۰ رقم باشد</span>
                            )}
                            {is500Error && (
                                <span className="text-red-500 text-sm">
                                    مشکلی در سرور رخ داده است، لطفاً بعداً دوباره امتحان کنید یا از طریق روش جایگزین
                                    ارتقا سطح اقدام نمایید.
                                </span>
                            )}
                        </div>
                        {showImage && (
                            <div
                                onClick={() => setShowImage(true)}
                                className="h-16 clickable w-full rounded-2xl border border-primary-20 bg-[#D7D7DC33] flex items-center justify-center gap-2"
                            >
                                <p className="font-bold text-base text-black-100 -mb-1">تصویر راهنما</p>
                                <FaImage className="text-base" />
                            </div>
                        )}
                        {!showImage && (
                            <div className="w-full flex items-center justify-center">
                                <Image
                                    width={400}
                                    className="rounded-md mx-auto"
                                    src={NationalCard}
                                    alt="selfie-image"
                                />
                            </div>
                        )}

                        {kycLink ? (
                            <>
                                <p className="text-sm text-center text-black-100">
                                    تا {seconds} ثانیه دیگه به صفحه احراز حرفه ای منتقل می‌شوید.
                                </p>
                                <p className="text-sm text-center text-black-100">
                                    در صورت تمایل به انتقال فوری، لطفاً دکمه‌ی ادامه را انتخاب نمایید.
                                </p>
                                <Button onClick={redirectToKyc} className="w-full mt-4" type="primary">
                                    ادامه
                                </Button>
                            </>
                        ) : (
                            <>
                                {is500Error ? (
                                    <div className="flex items-center gap-2 mt-4">
                                        <Button onClick={() => setIsManual(true)} className="flex-[2]" type="primary">
                                            روش جایگزین ارتقا سطح
                                        </Button>
                                        <Button
                                            className="flex-1 bg-background"
                                            type="text"
                                            onClick={() => props.onClose()}
                                        >
                                            بستن
                                        </Button>
                                    </div>
                                ) : (
                                    <Button
                                        onClick={submitHandler}
                                        loading={loading}
                                        disabled={!isValidSerial}
                                        className="w-full mt-4"
                                        type="primary"
                                    >
                                        ادامه احراز هویت
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                ) : (
                    <ProfileProfessionalManualVerifyModalContent
                        ref={profileProfessionalManualVerifyModalContentRef}
                        onClose={() => props.onClose(true)}
                        onBack={() => props.onClose(false)}
                    />
                )}
            </SiPayModal>
        );
    };

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(ProfileProfessionalVerifyModal);
